<template>
    <div class="card p-fluid">
        <h5>Enter Group Information</h5>
        <div class="formgrid grid">
            <div class="field col-4">
                <label for="code">Code (must be unique)</label>
                <InputText maxlength = "255" id="code" type="text" v-model="group.code" autofocus :class="{ 'p-invalid': submitted && !group.code }" placeholder="e.g  read_abc" />
                <small class="p-invalid" v-if="submitted && !group.code">Group Code is required and should be atleast 5 characters</small>
            </div>
            <div class="field col-6">
                <label for="description">Description</label>
                <InputText maxlength = "255" id="description" type="text" v-model="group.description" autofocus :class="{ 'p-invalid': submitted && !group.description }" placeholder="e.g  read/write full ... of abc ...." />
                <small class="p-invalid" v-if="submitted && !group.description">Group Description is required.</small>
            </div>
            <div class="field col-2">
                <div class="mb-2">Active</div>
                <ToggleButton v-model="group.active" onLabel="True" offLabel="False" :style="{ width: '7em' }" />
            </div>
            <div class="field col-12 lg:col-8">
                <label for="description">Add Permissions</label>
                <br /><small class="p-invalid" v-if="submitted && group.permissions.length <= 0">Select atleast one permission from the list.</small>
                <PickList v-model="sources" dataKey="id">
                    <template #sourceheader> All Permission List </template>
                    <template #targetheader> Added Permission List </template>
                    <template #item="slotProps">
                        <div>{{ slotProps.item.code }}</div>
                    </template>
                </PickList>
            </div>
            <div class="field col-2">
                <Button label="Submit" class="my-4" @click="submit"></Button>
            </div>
        </div>
    </div>
</template>

<script>
import PermissionService from '@/services/permission-service.js';
import GroupService from '@/services/group-service.js';

export default {
    name: 'AddNewGroup',
    props: {
        editGroup: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            mode: 'Add',
            editGroupId: null,
            editGroupPermissions: [],
            // @group only for submit values
            group: {
                code: null,
                description: null,
                active: false,
                permissions: [],
            },
            params: {
                paginate: false,
                product: 2, //Represents PHA
            },
            sources: null,
            submitted: false,
        };
    },
    permissionService: null,
    groupService: null,
    watch: {
        // As the sources are swapped into permissions, it will update the permissions values in real-time
        sources: {
            handler() {
                this.group.permissions = this.sources[1].map(function (item) {
                    return item.id;
                });
            },
        },
    },
    emits: ['group-created'],
    created() {
        this.permissionService = new PermissionService();
        this.groupService = new GroupService();
    },
    async mounted() {
        await this.loadPermissions(this.params);
        // console.log(this.sources)
        // check if its edit mode
        if (this.editGroup) {
            this.editGroupId = this.editGroup?.id;
            this.group.code = this.editGroup?.code;
            this.group.description = this.editGroup?.description;
            this.group.active = this.editGroup?.active ? true : false;
            // check if the editGroup has existing permissions
            // if yes then load accordingly
            const permissionIds = this.editGroup?.permissions?.map((item) => item.id);
            // console.log(permissionIds);
            if (this.editGroup?.permissions?.length) {
                this.sources[1] = this.editGroup.permissions;
                this.sources[0] = this.sources[0]?.filter((item) => !permissionIds.includes(item.id));
            }
            // console.log(this.sources);
        }
    },
    methods: {
        async loadPermissions(params) {
            await this.permissionService.getPermissions(params).then((response) => {
                if (response.statusCode == '200') {
                    this.sources = [response.data, []];
                }
            });
        },
        async submit() {
            this.submitted = true;
            if (this.validateGroupData()) {
                if (this.editGroupId) {
                    await this.updateGroup();
                } else {
                    await this.createGroup();
                }
            }
        },
        async createGroup() {
            await this.groupService.createGroup(this.group).then((data) => {
                if (data.statusCode == 201) {
                    this.$toast.add({ severity: 'success', summary: 'Created', detail: 'New Group has been added', life: 5000 });
                    // this.clearGroupFields();
                    this.submitted = false;
                    this.$emit('group-created', true);
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: data.message, life: 5000 });
                }
            });
        },
        async updateGroup() {
            await this.groupService.updateGroup(this.editGroupId, this.group).then((data) => {
                // console.log(data)
                if (data.statusCode == 201) {
                    this.$toast.add({ severity: 'success', summary: 'Updated', detail: 'Group has been updated', life: 5000 });
                    // this.clearGroupFields();
                    this.submitted = false;
                    // since the result output required is same in update, the emitted event is same as created
                    this.$emit('group-created', true);
                } else {
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: data.message, life: 5000 });
                }
            });
        },
        validateGroupData() {
            if (!this.group.code || !this.group.description || this.group.permissions.length <= 0) {
                return false;
            }
            return true;
        },
    },
};
</script>
